import React, { useEffect, useState } from 'react';
import {
  Card, Space, Typography, Radio, Skeleton, Empty, message,
  Descriptions, Tooltip, Popconfirm, Button, Result, Badge, Alert
} from 'antd';
import {
  HomeOutlined,
  EnvironmentOutlined,
  GlobalOutlined,
  ApartmentOutlined,
  IdcardOutlined,
  BankOutlined,
  MailOutlined,
  ProfileOutlined,
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  ReloadOutlined,
  InfoCircleOutlined
} from '@ant-design/icons';
import api from '../../services/api';
import { useLanguage } from '../../providers/LanguageProvider';


  const label = (icon: any, text: string) => (
    <Space size={6}>
      {React.cloneElement(icon, { style: { color: '#1677ff' } })}
      <span style={{ fontWeight: 500 }}>{text}</span>
    </Space>
  );


const { Title, Text } = Typography;
const InvoiceProfileCard = ({item,selectedId,handleEdit,handleSelect,loading,actionLoading,handleDelete,cardStyle}:{
    item:any,
    selectedId:any,
    handleEdit:any,
    handleSelect:any,
    loading:any,
    actionLoading:any,
    handleDelete:any,
    cardStyle?:React.CSSProperties

}) => {

    const {t} = useLanguage();

    return (
        <Card
            key={item.Id}
            size="small"
            onClick={() => handleSelect(item.Id)}
            title={
                <Space>
                    <span>{item.CompanyName}</span>
                    {selectedId === item.Id && (
                        <Badge status="success" text={t('INVOICE_DEFAULT')} style={{ fontSize: 12 }} />
                    )}
                </Space>
            }
            style={
                cardStyle ? cardStyle : { }
            }
            hoverable
            extra={
                <Space>
                    {/* <Radio
                        checked={selectedId === item.Id}
                        onChange={() => handleSelect(item.Id)}
                        disabled={actionLoading.select}
                    >
                        {t('INVOICE_DEFAULT')}
                    </Radio> */}
                    <Tooltip title={t('BTN_EDIT')}>
                        <Button
                            type="text"
                            icon={<EditOutlined style={{ color: '#1677ff' }} />}
                            onClick={() => handleEdit(item)}
                            disabled={loading}
                        />
                    </Tooltip>
                    <Popconfirm
                        title={t('INVOICE_DELETE_CONFIRM_TITLE')}
                        description={t('INVOICE_DELETE_CONFIRM_DESC')}
                        okText={t('INVOICE_DELETE_CONFIRM_OK')}
                        cancelText={t('BTN_CANCEL')}
                        onConfirm={() => handleDelete(item.Id)}
                        disabled={actionLoading[`delete-${item.Id}`]}
                    >
                        <Tooltip title={t('BTN_DELETE')}>
                            <Button
                                danger
                                type="text"
                                icon={<DeleteOutlined />}
                                loading={actionLoading[`delete-${item.Id}`]}
                                disabled={loading}
                            />
                        </Tooltip>
                    </Popconfirm>
                </Space>
            }
        >
            <Descriptions size="small" column={2} bordered={false} colon>
                <Descriptions.Item label={label(<HomeOutlined />, t('INVOICE_ADDRESS'))}>
                    {item.CompanyAddress || <Text type="secondary">{t('INVOICE_NOT_SPECIFIED')}</Text>}
                </Descriptions.Item>
                <Descriptions.Item label={label(<EnvironmentOutlined />, t('INVOICE_CITY_POSTAL'))}>
                    {item.CompanyCity && item.CompanyPostalCode
                        ? `${item.CompanyCity} / ${item.CompanyPostalCode}`
                        : <Text type="secondary">{t('INVOICE_NOT_SPECIFIED')}</Text>}
                </Descriptions.Item>
                <Descriptions.Item label={label(<GlobalOutlined />, t('LABEL_COUNTRY'))}>
                    {item.CompanyCountry || <Text type="secondary">{t('INVOICE_NOT_SPECIFIED')}</Text>}
                </Descriptions.Item>
                <Descriptions.Item label={label(<ApartmentOutlined />, t('INVOICE_TAX_OFFICE'))}>
                    {item.TaxOffice || <Text type="secondary">{t('INVOICE_NOT_SPECIFIED')}</Text>}
                </Descriptions.Item>
                <Descriptions.Item label={label(<IdcardOutlined />, t('INVOICE_TAX_NUMBER'))}>
                    {item.TaxNumber || <Text type="secondary">{t('INVOICE_NOT_SPECIFIED')}</Text>}
                </Descriptions.Item>
                <Descriptions.Item label={label(<ProfileOutlined />, t('INVOICE_CHAMBER_NUMBER'))}>
                    {item.ChamberOfCommerceNumber || <Text type="secondary">{t('INVOICE_NOT_SPECIFIED')}</Text>}
                </Descriptions.Item>
                <Descriptions.Item label={label(<BankOutlined />, t('INVOICE_IBAN'))}>
                    {item.IBAN || <Text type="secondary">{t('INVOICE_NOT_SPECIFIED')}</Text>}
                </Descriptions.Item>
                <Descriptions.Item label={label(<MailOutlined />, t('LABEL_EMAIL'))}>
                    {item.Email || <Text type="secondary">{t('INVOICE_NOT_SPECIFIED')}</Text>}
                </Descriptions.Item>
            </Descriptions>
        </Card>
    )
}

export default InvoiceProfileCard